module.exports = __webpack_public_path__ + "static/media/btg_celular_01.231ece4a.png";